import React, {Component} from "react";
import {connect} from "react-redux";

import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";

import imgInfo from "../../../resources/img/svgicons/info2.svg";

import Modal, {MODAL_VARIANTS} from "../generic/Modal";
import Button, {BUTTON_SIZES, BUTTON_VARIANTS} from "../generic/Button";
import Table, {TABLE_VARIANTS} from "../generic/Table";
import Input from "../generic/Input";

class DebugModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tab: null,
            active: "none",
            sectors: [],
            content: "",
            logLevel: windowService.getLogLevel(),
            btnSize: BUTTON_SIZES[2],
            btnVariant: BUTTON_VARIANTS[0],
            tableVariant: TABLE_VARIANTS[0],
            modalVariant: MODAL_VARIANTS[0]
        };
    }

    componentDidMount() {
        let sectors = Object.keys(this.props.store);

        this.setState({
            tab: "log",
            active: sectors[0],
            sectors: sectors,
            content: JSON.stringify(this.props.store[sectors[0]], null, 4),
            logLevel: windowService.getLogLevel(),
            logPath: windowService.getLogPath(),
            rccHelpPath: windowService.getRccHelpPath(this.props.store.settings.locale),
            uptime: window.storeProvider.getUptime()
        });
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseDebugModalAction();
    };

    handleSectorChange = (event) => {
        this.setState({
            active: event.target.value,
            content: JSON.stringify(this.props.store[event.target.value], null, 4)
        });
    };

    handleLogLevelClick = (event) => {
        if (windowService.setLogLevel(event.target.dataset.level)) {
            this.setState({logLevel: event.target.dataset.level});
        }
    };

    handleOpenDevToolsClick = () => {
        window.storeProvider.setDebugMode(true);
        windowService.openDevTools();
    };

    onTabClick = (event) => {
        this.setState({
            tab: event.currentTarget.dataset.tab
        });
    };

    getTabClassName = (tab) => {
        if (tab === this.state.tab) {
            return "general-tab active";
        }

        return "general-tab";
    };

    getTabList = () => {
        return (
            <div className="general-tabs primary-tabs">
                <div className="general-tab-list">
                    <div className={this.getTabClassName("log")} data-tab="log" onClick={this.onTabClick}>
                        Log level
                    </div>
                    <div className={this.getTabClassName("store")} data-tab="store" onClick={this.onTabClick}>
                        Store
                    </div>
                    <div className={this.getTabClassName("platform")} data-tab="platform" onClick={this.onTabClick}>
                        Platform
                    </div>
                    <div
                        className={this.getTabClassName("generic-components")}
                        data-tab="generic-components"
                        onClick={this.onTabClick}
                    >
                        Generic components
                    </div>
                </div>
            </div>
        );
    };

    getErrorLogButton = () => {
        if (this.state.logLevel === "error") {
            return <span className="text-danger">error</span>;
        }

        return (
            <a className="btn btn-info" href="#" data-level="error" onClick={this.handleLogLevelClick}>
                error
            </a>
        );
    };

    getWarningLogButton = () => {
        if (this.state.logLevel === "warn") {
            return <span className="text-warning margin-left-10">warn</span>;
        }

        return (
            <a className="btn btn-info margin-left-10" href="#" data-level="warn" onClick={this.handleLogLevelClick}>
                warn
            </a>
        );
    };

    getInfoLogButton = () => {
        if (this.state.logLevel === "info") {
            return <span className="text-info margin-left-10">info</span>;
        }

        return (
            <a className="btn btn-info margin-left-10" href="#" data-level="info" onClick={this.handleLogLevelClick}>
                info
            </a>
        );
    };

    getDebugLogButton = () => {
        if (this.state.logLevel === "debug") {
            return <span className="text-success margin-left-10">debug</span>;
        }

        return (
            <a className="btn btn-info margin-left-10" href="#" data-level="debug" onClick={this.handleLogLevelClick}>
                debug
            </a>
        );
    };

    getSectorList = () => {
        let sectorList = [];

        let sector;
        for (sector of this.state.sectors) {
            sectorList.push(<option key={sector}>{sector}</option>);
        }

        return (
            <select className="primary-select" value={this.state.active} onChange={this.handleSectorChange}>
                {sectorList}
            </select>
        );
    };

    getPlatformSection = () => {
        if (windowService.isBrowser()) {
            return (
                <div className="col-12 flex flex-wrap">
                    <div className="col-4">Uptime</div>
                    <div className="col-8">{this.state.uptime}</div>
                    <div className="col-4">Log file</div>
                    <div className="col-8">Not available</div>
                    <div className="col-4">RCC help path</div>
                    <div className="col-8">Not available</div>
                </div>
            );
        }

        return (
            <div className="col-12 flex flex-wrap">
                <div className="col-4">Uptime</div>
                <div className="col-8">{this.state.uptime}</div>
                <div className="col-4">Log file</div>
                <div className="col-8">{this.state.logPath}</div>
                <div className="col-4">RCC help path</div>
                <div className="col-8">{this.state.rccHelpPath}</div>
            </div>
        );
    };

    getLogLevelSection = () => {
        if (windowService.isBrowser()) {
            return "Log level settings are not available for browser.";
        }

        return (
            <div className="col-12">
                {this.getErrorLogButton()}
                {this.getWarningLogButton()}
                {this.getInfoLogButton()}
                {this.getDebugLogButton()}
                <a className="btn btn-success pull-right" href="#" onClick={this.handleOpenDevToolsClick}>
                    Dev Tools
                </a>
            </div>
        );
    };

    changeBtnSize = (event) => {
        this.setState({
            btnSize: event.target.value
        });
    };

    changeBtnVariant = (event) => {
        this.setState({
            btnVariant: event.target.value
        });
    };

    changeTableVariant = (event) => {
        this.setState({
            tableVariant: event.target.value
        });
    };

    changeModalVariant = (event) => {
        this.setState({
            modalVariant: event.target.value
        });
    };

    getGenericComponentsSection = () => {
        return (
            <div className="col-12 flex flex-wrap flex-gap-0_6rem">
                <div className="col-12 flex flex-align-center-vertical flex-space-between">
                    <select
                        className="primary-select"
                        value={this.state.modalVariant}
                        onChange={this.changeModalVariant}
                    >
                        {MODAL_VARIANTS.map((variant) => (
                            <option value={variant} key={variant}>
                                {variant}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12 flex flex-align-center-vertical flex-space-between">
                    <select className="primary-select" value={this.state.btnVariant} onChange={this.changeBtnVariant}>
                        {BUTTON_VARIANTS.map((variant) => (
                            <option value={variant} key={variant}>
                                {variant}
                            </option>
                        ))}
                    </select>
                    <select className="primary-select" value={this.state.btnSize} onChange={this.changeBtnSize}>
                        {BUTTON_SIZES.map((variant) => (
                            <option value={variant} key={variant}>
                                {variant}
                            </option>
                        ))}
                    </select>
                    <Button
                        variant={this.state.btnVariant}
                        size={this.state.btnSize}
                        label="Example"
                        svgBefore={imgInfo}
                    />
                    <Button
                        variant={this.state.btnVariant}
                        size={this.state.btnSize}
                        className="active"
                        label="Example active"
                        svgBefore={imgInfo}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical flex-space-between flex-gap-10px">
                    <select
                        className="primary-select"
                        value={this.state.tableVariant}
                        onChange={this.changeTableVariant}
                    >
                        {TABLE_VARIANTS.map((variant) => (
                            <option value={variant} key={variant}>
                                {variant}
                            </option>
                        ))}
                    </select>
                    <div className="flex flex-child fill-flex-space flex-column" style={{maxHeight: "250px"}}>
                        <Table
                            variant={this.state.tableVariant}
                            className=" flex-child fill-flex-space"
                            allowToggleSubRows={false}
                            renderSubRows={true}
                            tableHeader={modelHelper.buildTableRow([
                                modelHelper.buildTableCell("Header 1"),
                                modelHelper.buildTableCell("Header 2"),
                                modelHelper.buildTableCell("Header 3")
                            ])}
                            tableRows={[
                                modelHelper.buildTableRow(
                                    [
                                        modelHelper.buildTableCell("Data 1-1"),
                                        modelHelper.buildTableCell("Data 1-2"),
                                        modelHelper.buildTableCell("Data 1-3")
                                    ],
                                    "",
                                    undefined,
                                    {},
                                    [
                                        modelHelper.buildTableRow(
                                            [
                                                modelHelper.buildTableCell("Data 1-1-1"),
                                                modelHelper.buildTableCell("Data 1-1-2"),
                                                modelHelper.buildTableCell("Data 1-1-3")
                                            ],
                                            "",
                                            undefined,
                                            {},
                                            [
                                                modelHelper.buildTableRow([
                                                    modelHelper.buildTableCell("Data 1-1-1-1"),
                                                    modelHelper.buildTableCell("Data 1-1-1-2"),
                                                    modelHelper.buildTableCell("Data 1-1-1-3")
                                                ]),
                                                modelHelper.buildTableRow(
                                                    [
                                                        modelHelper.buildTableCell("Data 1-1-2-1"),
                                                        modelHelper.buildTableCell("Data 1-1-2-2"),
                                                        modelHelper.buildTableCell("Data 1-1-2-3")
                                                    ],
                                                    "",
                                                    undefined,
                                                    {},
                                                    [
                                                        modelHelper.buildTableRow(
                                                            [
                                                                modelHelper.buildTableCell("Data 1-1-2-1-1"),
                                                                modelHelper.buildTableCell("Data 1-1-2-1-2"),
                                                                modelHelper.buildTableCell("Data 1-1-2-1-3")
                                                            ],
                                                            "",
                                                            undefined,
                                                            {},
                                                            [
                                                                modelHelper.buildTableRow([
                                                                    modelHelper.buildTableCell("Data 1-1-2-1-1-1"),
                                                                    modelHelper.buildTableCell("Data 1-1-2-1-1-2"),
                                                                    modelHelper.buildTableCell("Data 1-1-2-1-1-3")
                                                                ]),
                                                                modelHelper.buildTableRow(
                                                                    [
                                                                        modelHelper.buildTableCell("Data 1-1-2-1-2-1"),
                                                                        modelHelper.buildTableCell("Data 1-1-2-1-2-2"),
                                                                        modelHelper.buildTableCell("Data 1-1-2-1-2-3")
                                                                    ],
                                                                    "",
                                                                    undefined,
                                                                    {},
                                                                    [
                                                                        modelHelper.buildTableRow([
                                                                            modelHelper.buildTableCell(
                                                                                "Data 1-1-2-1-1"
                                                                            ),
                                                                            modelHelper.buildTableCell(
                                                                                "Data 1-1-2-1-2"
                                                                            ),
                                                                            modelHelper.buildTableCell("Data 1-1-2-1-3")
                                                                        ]),
                                                                        modelHelper.buildTableRow([
                                                                            modelHelper.buildTableCell(
                                                                                "Data 1-1-2-2-1"
                                                                            ),
                                                                            modelHelper.buildTableCell(
                                                                                "Data 1-1-2-2-2"
                                                                            ),
                                                                            modelHelper.buildTableCell("Data 1-1-2-2-3")
                                                                        ])
                                                                    ]
                                                                )
                                                            ]
                                                        ),
                                                        modelHelper.buildTableRow([
                                                            modelHelper.buildTableCell("Data 1-1-2-2-1"),
                                                            modelHelper.buildTableCell("Data 1-1-2-2-2"),
                                                            modelHelper.buildTableCell("Data 1-1-2-2-3")
                                                        ])
                                                    ]
                                                )
                                            ]
                                        ),
                                        modelHelper.buildTableRow([
                                            modelHelper.buildTableCell("Data 1-2-1"),
                                            modelHelper.buildTableCell("Data 1-2-2"),
                                            modelHelper.buildTableCell("Data 1-2-3")
                                        ])
                                    ],
                                    true
                                ),
                                modelHelper.buildTableRow(
                                    [
                                        modelHelper.buildTableCell("Data 2-1"),
                                        modelHelper.buildTableCell("Data 2-2"),
                                        modelHelper.buildTableCell("Data 2-3")
                                    ],
                                    "active"
                                ),
                                modelHelper.buildTableRow([
                                    modelHelper.buildTableCell("Data 3-1"),
                                    modelHelper.buildTableCell("Data 3-2"),
                                    modelHelper.buildTableCell("Data 3-3")
                                ])
                            ]}
                            tableColumns={[
                                modelHelper.buildTableColumn("col-6 vertical-center", true),
                                modelHelper.buildTableColumn("col-3 vertical-center"),
                                modelHelper.buildTableColumn("col-3 vertical-center")
                            ]}
                        />
                    </div>
                </div>
                <div className="col-12 flex flex-align-center-vertical flex-space-between">
                    <Input className="primary-input col-2" labelBefore="Before" value="value" />
                    <Input className="primary-input col-2" value="value" />
                    <Input className="primary-input col-2" labelAfter="After" value="value" />
                    <Input className="primary-input col-2" labelBefore="Before" labelAfter="After" value="value" />
                </div>
            </div>
        );
    };

    getActiveTab = () => {
        if (this.state.tab === "log") {
            return this.getLogLevelSection();
        }

        if (this.state.tab === "store") {
            return (
                <div className="col-12 flex flex-wrap">
                    <div className="col-2">Store</div>
                    <div className="col-10">{this.getSectorList()}</div>
                    <textarea
                        className="slim-scroll fill-flex-space flex-child"
                        readOnly={true}
                        value={this.state.content}
                        style={{
                            resize: "none",
                            minHeight: "30vh",
                            width: "100%",
                            marginTop: "10px"
                        }}
                    />
                </div>
            );
        }

        if (this.state.tab === "platform") {
            return this.getPlatformSection();
        }

        if (this.state.tab === "generic-components") {
            return this.getGenericComponentsSection();
        }

        return "";
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                variant={this.state.modalVariant}
                header={modelHelper.buildModalSection("Debug")}
                content={modelHelper.buildModalSection(
                    <div className="general-tabs primary-tabs">
                        {this.getTabList()}
                        <div className="general-tab-content flex flex-column slim-scroll">{this.getActiveTab()}</div>
                    </div>,
                    "flex flex-column flex-child fill-flex-space"
                )}
                styles={{
                    minWidth: "50%",
                    minHeight: "60%"
                }}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        store: store
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDebugModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.DEBUG_MODAL));
        }
    };
};

export default DebugModal = connect(mapStoreToProps, mapDispatchToProps)(DebugModal);
